const state = {
  availableDate: null,
  startDate: null,
  lastClosedDate: null,
  menuOpen: true,
  currentSubmenu: localStorage.getItem('currentSubmenu') === null ? [] : localStorage.getItem('currentSubmenu').split(','),
  loading: false,
  showViewAdmin: false
};

const getters = {
  getAvailableDate: state => {
    return state.availableDate
  },
  getStartDate: state => {
    return state.startDate;
  },
  getLastClosedDate: state => {
    return state.lastClosedDate;
  },
  getCurrentSubmenu: state => state.currentSubmenu,
  isMenuOpen : state=> state.menuOpen,
  isLoading: state => state.loading,
  getShowViewAdmin: state => {
    return state.showViewAdmin;
  }
};

const actions = {
  loading: (store, val) => {
    store.commit('setLoading', val)
  }
};

const mutations = {
  setShowViewAdmin(state, value) {
    state.showViewAdmin = value;
  },
  availableDate(state, value) {
    state.availableDate = value;
  },
  startDate(state, value) {
    state.startDate = value;
  },
  lastClosedDate(state, value) {
    state.lastClosedDate = value;
  },
  setCurrentSubmenu(state, value) {
      const values = state.currentSubmenu
      state.currentSubmenu = values.includes(value)?  values.filter(e => e !== value) : [...values, value]
      localStorage.setItem('currentSubmenu', state.currentSubmenu)
  },
  toggleMenu(state) {
    if (!window.matchMedia("(max-width: 768px)").matches) {
      state.menuOpen = !state.menuOpen
    }
  },
  setMenu(state, value) {
    state.menuOpen = value
  },
  setLoading(state, value) {
    state.loading = value
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
